jQuery(document).ready(function($) {

    $( ".bloc_mobile" ).each(function( index ) {

        var parent = $(this)
        var cibleAcces = parent.find(".visuel")

        // décalage réduit sous 768px : le visuel passe sous le texte, en pleine largeur
        gsap.from( cibleAcces, {
            opacity: 0,
            x : function () {
                return window.matchMedia("(max-width: 767.98px)").matches ? -60 : -200
            },
            duration: 1,
            ease: "power2.out",
            scrollTrigger: {
                trigger: parent,
                markers: false,
                start: "top 80%",
                end: "bottom 100%",
                scrub: 1,
                invalidateOnRefresh: true,
            }

        })

    })

});